import { FC, MouseEventHandler } from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Nullable } from 'common-types';
import { Organization } from '../../organizations/organization-types';
import ApiKeySettingsHeader from '../../api-key-settings/components/ApiKeySettingsHeader';
import ApiKeySettingsContainer from '../../api-key-settings/containers/ApiKeySettingsContainer';
import CreteApiKeyButton from '../../api-key-settings/components/CreateApiKeyButton';

const ApiKeySettingsTab: FC<
  React.PropsWithChildren<ApiKeySettingsTabProps>
> = props => {
  const { classes } = useStyles();
  const { chosenOrganization, isUserAdminRole } = props;
  if (!chosenOrganization) {
    return null;
  }

  return (
    <>
      <div className={classes.settingsTab}>
        <ApiKeySettingsHeader />
        <div className={classes.createApiKeyButton}>
          <CreteApiKeyButton isUserAdminRole={isUserAdminRole} />
        </div>
        <ApiKeySettingsContainer isUserAdminRole={isUserAdminRole} />
      </div>
    </>
  );
};

interface ApiKeySettingsTabProps {
  chosenOrganization: Nullable<Organization>;
  isUserAdminRole: boolean;
  showRemoveOrgModal: MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles()((theme: Theme) => ({
  settingsTab: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  createApiKeyButton: {
    display: 'flex',
  },
}));

export default ApiKeySettingsTab;
